export default __webpack_public_path__ + "static/media/startup2.1240f5ef.gif";